import { TimerOutlined } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const WaitListSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.wait-list" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/wait-list/item">
          <List.ItemIcon>
            <TimerOutlined />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.wait-list.item.title" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
